module.exports = __webpack_public_path__ + "assets/images/06-balloon_b51272c4a29aaea79f1ca7f088e7619e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/06-balloon.png
// module id = 177
// module chunks = 0